var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectFeatureSearchContext } from "./selectors.js";
import { setSearchContext } from "./actions.js";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import Logger from "@ane/core/lib/services/logging/Logger";
const useFeatureSearch = (options) => {
  const { eagerLoad = true } = options || {};
  const dispatch = useDispatch();
  const [contextState, setContextState] = useState(useSelector(selectFeatureSearchContext));
  const commitContext = () => dispatch(setSearchContext(contextState));
  useEffect(() => {
    if (!eagerLoad) {
      return;
    }
    commitContext();
  }, [eagerLoad, contextState]);
  return {
    context: contextState,
    clearContext: (rootExperimentationGroup) => setContextState({ experimentationGroup: [rootExperimentationGroup] }),
    setPartialContext: (context) => setContextState((prev) => __spreadValues(__spreadValues({}, prev), context)),
    setContext: setContextState,
    commitContext
  };
};
const useTrackLoadTime = (statuses, trackingName, workspaceId, startToBtachCall) => {
  var _a, _b, _c, _d;
  const startName = `${trackingName}-${workspaceId}-start`;
  const endName = `${trackingName}-${workspaceId}-end`;
  const startTimeMarked = ((_b = (_a = performance == null ? void 0 : performance.getEntriesByName) == null ? void 0 : _a.call(performance, startName)) == null ? void 0 : _b.length) > 0;
  const endTimeMarked = ((_d = (_c = performance == null ? void 0 : performance.getEntriesByName) == null ? void 0 : _c.call(performance, endName)) == null ? void 0 : _d.length) > 0;
  useEffect(() => {
    var _a2, _b2, _c2, _d2, _e;
    if (!startTimeMarked) {
      if (startToBtachCall) {
        (_a2 = performance == null ? void 0 : performance.mark) == null ? void 0 : _a2.call(performance, startName);
      } else {
        const firstPendingIndex = statuses.findIndex((status) => status === AsyncRequestStatus.Pending);
        if (firstPendingIndex !== -1) {
          (_b2 = performance == null ? void 0 : performance.mark) == null ? void 0 : _b2.call(performance, startName);
        }
      }
    }
    const allFinished = (statuses == null ? void 0 : statuses.length) > 0 && statuses.every((status) => status === AsyncRequestStatus.Completed || status === AsyncRequestStatus.Failed);
    const failedRequestCount = statuses.filter((status) => status === AsyncRequestStatus.Failed).length;
    if (allFinished && startTimeMarked && !endTimeMarked) {
      (_c2 = performance == null ? void 0 : performance.mark) == null ? void 0 : _c2.call(performance, endName);
      const measure = (_e = (_d2 = performance == null ? void 0 : performance.measure) == null ? void 0 : _d2.call(performance, `${trackingName}-${workspaceId}-measure`, startName, endName)) == null ? void 0 : _e.toJSON();
      Logger.trackMetric({
        name: trackingName,
        average: measure.duration,
        properties: {
          totalRequests: statuses.length,
          totalFailedRequests: failedRequestCount,
          measureStartTime: measure == null ? void 0 : measure.startTime
        }
      });
    }
  }, [statuses]);
};
export {
  useFeatureSearch,
  useTrackLoadTime
};
//# sourceMappingURL=hooks.js.map
